/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Scopri gente nuova, chatta, socializza",
      "Numero di telefono errato",
      "Get the app",
      "Continua con Apple",
      "Continua con Facebook",
      "Continua con Google",
      "Accedi",
      "Registrati",
      "Per continuare, inserisci i caratteri che visualizzi nel riquadro.",
      "Continua",
      "Inserisci caratteri",
      "Controllo di sicurezza",
      "Ricarica",
      "Crea una nuova password facile da ricordare:",
      "Aggiorna",
      "Conferma la password",
      "Deve contenere almeno {{num}} [[characters:num]]",
      "Password",
      "Crea nuova password",
      "Badoo - The Blog",
      "Lavora con noi",
      "Chat",
      "Città",
      "Preferenze cookie",
      "Copyright © 2006 – presente. Bumble. Tutti i diritti riservati.",
      "Apple e il logo di Apple sono marchi di Apple Inc.{{__EOL__}}Google Play è un marchio di Google LLC.",
      "Scarica",
      "Facebook",
      "Seguici",
      "AIuto",
      "Instagram",
      "Lingua",
      "LinkedIn",
      "Panoramica",
      "Badoo fa parte di Bumble Inc.",
      "Informativa sulla privacy",
      "Safety Centre",
      "Mappa del sito",
      "Dichiarazione sulle leggi contro la schiavitù moderna",
      "Condizioni d'utilizzo",
      "Twitter",
      "Inserisci la tua e-mail o il tuo numero di cellulare e ti invieremo le istruzioni per creare una nuova password.",
      "Richiedi nuova password",
      "Inserisci e-mail o numero di telefono",
      "Password dimenticata",
      "Modelli utilizzati solo per scopi illustrativi",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Non devi aspettare che scatti l'affinità.{{__EOL__}}{{__EOL__}}Fai conversazioni più profonde e vai direttamente al sodo, in modo da approfondire la conoscenza.",
      "Tutto pronto per chattare?",
      "Registrandoti, accetti le nostre <a class=\"link\" href=\"{{terms_url}}\">Condizioni di utilizzo</a>. <br/>Per informazioni sulle modalità di utilizzo dei tuoi dati, consulta la nostra <a class=\"link\" href=\"{{privacy_url}}\">Informativa sulla privacy</a>.",
      "Ti aiutiamo a mostrarti per quello che sei, <br />per farti conoscere persone che ti fanno sentire a tuo agio.",
      "Appuntamenti in tutta tranquillità",
      "oppure",
      "Hai già un account?",
      "Registrati con il tuo indirizzo email o numero di telefono",
      "Ottieni ciò che desideri dagli appuntamenti.{{__EOL__}}Non serve scusarsi.",
      "Hai solo voglia di chiacchierare? Perfetto.{{__EOL__}}Cerchi qualcosa di serio? Fantastico.{{__EOL__}}{{__EOL__}}E se cambi idea, nessun problema!",
      "Sono qui per incontrare gente",
      "Voglio una relazione",
      "Voglio chattare",
      "Incontra persone che hanno le tue stesse finalità.",
      "{{name}}, {{age}}",
      "La tua sicurezza è la nostra priorità.",
      "Nel nostro Safety Centre troverai tutto ciò di cui hai bisogno per appuntamenti in totale sicurezza.",
      "Visita il nostro Safety Centre",
      "La sicurezza prima di tutto, sempre.",
      "Da subito ho pensato che avrebbe funzionato...",
      "All'inizio non cercavo nulla di serio…",
      "Un consiglio per chi utilizza l'app Badoo: essere semplicemente se stessi...",
      "Badoo: storie di successo",
      "Dai un'occhiata ad altre storie di successo",
      "{{num}}__CUT__Valutazione",
      "App Store di Apple",
      "Fidati di noi. Abbiamo fatto conoscere milioni e milioni di persone dal 2006.",
      "Più di {{num}} milioni__CUT__di download",
      "Più di {{num}} milioni",
      "Google Play Store",
      "Sappiamo quello che facciamo.",
      "Accedi con e-mail o numero di telefono",
      "Inserisci la tua password",
      "Password dimenticata?",
      "Registrati",
      "Non hai un account?",
      "Accesso",
      "Registrati"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caratteri"
            ],
            "singular": [
                  "carattere"
            ]
      },
      "day": {
            "plural": [
                  "giorni"
            ],
            "singular": [
                  "giorno"
            ]
      },
      "hour": {
            "plural": [
                  "ore"
            ],
            "singular": [
                  "ora"
            ]
      },
      "minute": {
            "plural": [
                  "minuti"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mesi"
            ],
            "singular": [
                  "mese"
            ]
      },
      "second": {
            "plural": [
                  "secondi"
            ],
            "singular": [
                  "secondo"
            ]
      },
      "year": {
            "plural": [
                  "anni"
            ],
            "singular": [
                  "anno"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
